module.exports = __webpack_public_path__ + "img/loading.0b259f87.gif";